const privateKeys = new Set(["_id", "id", "generated_at", "evidence_ids", "source_story_ids", "source_ids"]);
const plainKeys = new Set(["detail", "position", "summary", "description", "stance", "text", "analysis", "event", "point"]);
const titleKeys = ["title", "label", "topic", "headline", "domain"];

export const analysisBlocks = (value, prefix) => {
  const pending = [{ value, id: prefix }];
  const blocks = [];
  while (pending.length) {
    const node = pending.pop();
    if (node.heading) { blocks.push({ id: node.id, kind: "heading", text: node.heading }); continue; }
    if (node.value == null || typeof node.value === "boolean") continue;
    if (typeof node.value !== "object") { blocks.push({ id: node.id, kind: "text", text: String(node.value) }); continue; }
    if (Array.isArray(node.value)) {
      for (let i = node.value.length - 1; i >= 0; i--) pending.push({ value: node.value[i], id: `${node.id}-${i}` });
      continue;
    }
    const headingKey = titleKeys.find(k => typeof node.value[k] === "string" && node.value[k]);
    const entries = Object.entries(node.value).filter(([key]) => !privateKeys.has(key) && key !== headingKey);
    for (let i = entries.length - 1; i >= 0; i--) {
      const [key, child] = entries[i];
      const id = `${node.id}-${key}`;
      pending.push({ value: child, id });
      if (!plainKeys.has(key) && key !== "date" && !titleKeys.includes(key)) pending.push({ heading: key.replace(/_/g, " "), id: `${id}-heading` });
    }
    if (headingKey) pending.push({ heading: node.value[headingKey], id: `${node.id}-heading` });
  }
  return blocks;
};